const fmt = (cents) =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);

class CartShippingEstimate extends HTMLElement {
  #unsubscribe = null;
  #rates = [];

  connectedCallback() {
    try {
      // Rates are [{w: max_weight_kg, p: price_dollars}, ...] sorted ascending
      this.#rates = JSON.parse(this.dataset.rates || '[]').sort((a, b) => a.w - b.w);
    } catch {
      this.#rates = [];
    }

    this.#render({
      item_count: Number(this.dataset.itemCount),
      total_price: Number(this.dataset.totalPrice),
      total_weight: Number(this.dataset.totalWeight),
    });

    this.#unsubscribe = subscribe('cart-update', (data) => {
      data?.cartData ? this.#render(data.cartData) : this.#fetchAndRender();
    });
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
  }

  async #fetchAndRender() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      this.#render(await res.json());
    } catch { /* leave current state */ }
  }

  #render(cart) {
    if (!cart?.item_count || !this.#rates.length) { this.hidden = true; return; }

    const weightKg = cart.total_weight / 1000;
    const tier = this.#rates.find((r) => weightKg <= r.w);
    if (!tier) { this.hidden = true; return; }

    const shippingCents = Math.round(tier.p * 100);
    this.querySelector('.shipping-estimate__shipping').textContent = fmt(shippingCents);
    this.querySelector('.shipping-estimate__total').textContent = fmt(cart.total_price + shippingCents);

    const nudgeEl = this.querySelector('.shipping-estimate__nudge');
    nudgeEl.hidden = shippingCents / cart.total_price < 0.25;

    this.hidden = false;
  }
}

if (!customElements.get('cart-shipping-estimate')) {
  customElements.define('cart-shipping-estimate', CartShippingEstimate);
}
